import { Tabs } from 'antd'
import styled from 'styled-components'
import { accessibilityColors } from '@edulastic/colors'

const { TabPane } = Tabs

/** Matches DashboardSubHeader Classes / Assignments tab styling. */
export const StyledTabs = styled(Tabs)`
  .ant-tabs-bar {
    margin-bottom: 0;
  }

  .ant-tabs-content {
    display: none;
  }

  .ant-tabs-tab {
    padding: 12px 5px;
    margin-right: 15px;
    font-size: 14px;
    font-weight: 600;
  }

  .ant-tabs-tab-active {
    font-weight: 700;
    color: ${accessibilityColors.theme.greenDarker};
  }

  .ant-tabs-tab:hover {
    color: ${accessibilityColors.theme.greenDarker};
  }

  .ant-tabs-ink-bar {
    height: 2.5px;
  }
`

export { TabPane }
